import { useEffect } from 'react';

/**
 * Warns on tab close/reload while `active` is true. No custom message possible (browser-enforced).
 * KNOWN LIMITATION (code-review, 2026-07-25): this only covers hard exits (tab close/reload/leaving
 * the origin) via `beforeunload`. It does NOT catch in-app SPA navigation (BackBar's "Back to job"
 * link, browser Back/Forward resolving to a React-Router transition) — those leave silently with no
 * warning. Catching those would need React Router's `useBlocker`, which requires a Data Router
 * (`createBrowserRouter`/`RouterProvider`); this app uses plain `<BrowserRouter>` (App.js), so adding
 * it means a router migration, out of scope here. Deliberately accepted, not silently missed.
 */
export default function useExitIntentGuard(active) {
  useEffect(() => {
    if (!active) return undefined;
    function handleBeforeUnload(e) {
      e.preventDefault();
      e.returnValue = '';
    }
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [active]);
}
